import React from 'react';
import PropTypes from 'prop-types';

import {
  Paragraph,
  Text,
  Strong,
  ScreenReaderOnly
} from 'seek-style-guide/react';

const RightToWork = ({ required }) =>
  required && (
    <div>
      <ScreenReaderOnly>
        <h2>Right to live and work</h2>
      </ScreenReaderOnly>
      <Paragraph>
        <Text small data-automation="rightToWorkRequired">
          You must have the
          <Strong> right to live and work </Strong>
          in this location to apply for this job.
        </Text>
      </Paragraph>
    </div>
  );

RightToWork.propTypes = {
  required: PropTypes.bool.isRequired
};

export default RightToWork;
